import { useComponentRegistry } from '@bem-react/di';
import { ITextinputProps } from '@yandex-lego/components/Textinput';
import React, { FormEventHandler, ReactNode } from 'react';
import { Omit } from 'utility-types';

import cn from 'utils/cn';

import './index.css';

export interface ISearchProps extends Omit<ITextinputProps, 'type'> {
    siteSearchUrl?: string;
    hidden?: boolean;
    addonInside?: ReactNode;
    addonBefore?: ReactNode;
    onSubmit?: FormEventHandler;
}

export const cnSearch = cn('search');

function Search({ className, hidden, addonInside, addonBefore, onSubmit, ...props }: ISearchProps) {
    const { Textinput } = useComponentRegistry('lego');

    const { controlRef, value, placeholder, onKeyDown, onChange, onFocus, onBlur } = props;

    return (
        <form
            className={cnSearch({}, [className])}
            onSubmit={onSubmit}
            >
            { addonBefore }
            <div style={{ opacity: Number(!hidden) }} className={cnSearch('input', [className])}>
                <Textinput
                    value={value}
                    placeholder={placeholder}
                    theme="normal"
                    size="m"
                    view="classic"
                    controlRef={controlRef}
                    hasClear
                    onKeyDown={onKeyDown}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    />
                { addonInside }
            </div>
        </form>
    );
}

export default Search;
